<template>
  <v-row justify="center">
    <v-btn text @click="contactDialog = true">Contact</v-btn>

    <v-dialog v-model="contactDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline font-weight-black pl-6 pt-4 pr-0">
          Contact Us
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 darken-1 pr-0" text @click="contactDialog = false">
            <v-icon class="pa-0" size="20px">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-row class="ma-0 px-6 pt-5 pb-5 ">
          <v-col cols="12 ">
            <v-row class="setStyleColContent">
              <v-col class="py-12" cols="12" xl="4" lg="4" md="4" sm="12">
                <v-row justify="space-around" class="ma-0">
                  <v-avatar size="150px">
                    <img src="@/assets/culi/logo-company.png" />
                  </v-avatar>
                </v-row>
                <div
                  class="organizeTitle title font-weight-bold"
                >Chulalongkorn University Language Institute</div>
              </v-col>

              <v-divider vertical></v-divider>
              <v-divider class="showDivider"></v-divider>

              <v-col cols="12" xl="7" lg="7" md="7" sm="12" class="pa-6">
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Tel</span>
                </div>
                <div>
                  <span class="title font-weight-bold">+662 218 6012</span>
                </div>
                <br />
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Address</span>
                </div>
                <div>
                  <span
                    class="title font-weight-bold"
                  >Prem Purachatra Building, Phayathai Road, Pathumwan, Bangkok 10330</span>
                </div>
                <br />
                <div>
                  <span class="subtitle-1 font-weight-medium grey--text text--lighten-1">Facebook</span>
                </div>
                <div>
                  <span class="title font-weight-bold">www.facebook.com/CULIChula</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
       
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      contactDialog: false
    };
  }
};
</script>
<style scoped>
.organizeTitle {
  text-align: center;
}
.setStyleColContent {
  border: 0.5px solid #e5e5e6;
}
.setStyleColLogo {
  border-left: 0.5px solid #e5e5e6;
  border-top: 0.5px solid #e5e5e6;
  border-bottom: 0.5px solid #e5e5e6;
  border-right: 0.5px solid #e5e5e6;
}
@media only screen and (min-width: 961px) {
    .showDivider {
        display: none;
    }
}
</style>